module.exports = __webpack_public_path__ + "img/account_placeholder.1825496e.png";